<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.pt-8.pb-0
      .mb-8
        .d-flex.align-center.mb-4
          //- v-btn.mr-4(icon small)
          //-   v-icon(color="primary" @click="onClose") mdi-close
          .ml-4.text-2xl.font-semibold.neutral700--text {{ documentName }}
        .d-flex.justify-center
          div(style="width:90%;")
            v-row.neutral700--text(no-gutters)
              v-col.white.pa-8.round-xl.border
                template(v-if="isFetching")
                  v-skeleton-loader.pa-4(type="list-item-three-line@6")
                template(v-else)
                  //- For medical certificate
                  template(v-if="documentCategory === 'medical_certificate'")
                    //- Instruction
                    .text-md.font-semibold.mb-2 {{ $t('medical_certificate_instruction') }}
                    //- Date of visit
                    .my-5
                      .text-sm.font-semibold.neutral700--text.mb-1 {{ $t('date_of_visit') }}
                      v-sheet.text-sm.round-xl.clickable.border-field(flat outlined min-width="240" @click="onOpenSelectDateDialog('visitDate')")
                        .d-flex.align-center.justify-space-between.px-4(style="min-height: 47px;")
                          .text-sm.neutral700--text(v-if="visitDate") {{ visitDate | convertToDateOnly }}
                          .text-sm.neutral500--text(v-else) Select visit date
                          v-icon(size="20") $yzi-calendar
                    //- Doctor
                    .my-5
                      div.text-sm.font-semibold.neutral700--text.mt-4 {{ $t('doctor') }}
                      y-select.mt-2(v-model="selectedProvider" :items="providers" item-text="name" item-value="name" :placeholder="$t('select_doctor')")
                    .my-5
                      .d-flex.align-center
                        //- No of days
                        div.shrink
                          .text-sm.font-semibold.neutral700--text.mb-1 {{ $t('no_of_days') }}
                          v-text-field.text-sm.round-xl(v-model.number="noOfDays" outlined dense height="48" min="1" type="number" hide-details="auto" @input="onNoOfDaysChanged")
                        //- Start date
                        div.ml-4.grow
                          .text-sm.font-semibold.neutral700--text.mb-1 {{ $t('start_date') }}
                          v-sheet.text-sm.round-xl.clickable.border-field(flat outlined min-width="240" @click="onOpenSelectDateDialog('startDate')")
                            .d-flex.align-center.justify-space-between.px-4(style="min-height: 47px;")
                              .text-sm.neutral700--text(v-if="startDate") {{ startDate | convertToDateOnly }}
                              .text-sm.neutral500--text(v-else) Select start date
                              v-icon(size="20") $yzi-calendar
                        //- End date
                        div.ml-4.grow
                          .text-sm.font-semibold.neutral700--text.mb-1 {{ $t('end_date') }}
                          v-sheet.text-sm.round-xl.clickable.border-field(flat outlined min-width="240" @click="onOpenSelectDateDialog('endDate')")
                            .d-flex.align-center.justify-space-between.px-4(style="min-height: 47px;")
                              .text-sm.neutral700--text(v-if="endDate") {{ endDate | convertToDateOnly }}
                              .text-sm.neutral500--text(v-else) Select end date
                              v-icon(size="20") $yzi-calendar
                    //- Diagnosis
                    .my-5
                      .text-sm.font-semibold.neutral700--text.mb-1 {{ $t('diagnosis') }}
                      diagnosis-field-dropdown(:parentDiagnosis="selectedDiagnosis" :leadPid="leadPid" attach isIndependent min-height="48" @updated="onUpdateDiagnosis")
                    // Dependent of the patient
                    .my-5
                      .text-sm.font-semibold.neutral700--text.mb-1 This patient is dependent of (Optional)
                      patient-relationship-dropdown(v-model="selectedPatientDependent" :patient-id="patient.id" clearable)
                  //- For prescription letter
                  template(v-else-if="documentCategory === 'prescription_letter'")
                    //- Instruction
                    .text-md.font-semibold.mb-2 Fill out information below to complete document
                    //- Date
                    .my-5
                      .text-sm.font-semibold.neutral700--text.mb-1 Date
                      v-sheet.text-sm.round-xl.clickable.border-field(flat outlined min-width="240" @click="onOpenSelectDateDialog('visitDate')")
                        .d-flex.align-center.justify-space-between.px-4(style="min-height: 47px;")
                          .text-sm.neutral700--text(v-if="visitDate") {{ visitDate | convertToDateOnly }}
                          .text-sm.neutral500--text(v-else) Select date
                          v-icon(size="20") $yzi-calendar
                    //- Doctor
                    .my-5
                      div.text-sm.font-semibold.neutral700--text.mt-4 {{ $t('doctor') }}
                      y-select.mt-2(v-model="selectedProvider" :items="providers" item-text="name" item-value="name" :placeholder="$t('select_doctor')")
                    //- Medications
                    .my-5
                      .text-sm.font-semibold.neutral700--text.mb-1 Medications
                      prescription-letter-medication-selection(:medications="medications")
                  //- For medical documents
                  template(v-else)
                    .text-md.font-semibold.mb-4 {{ $t('editor') }}
                    .text-sm.font-medium.mb-2 {{ $t('compose_content') }}
                    text-editor(:parentForm.sync="content" :category="documentCategory")
              v-col.pl-8
                preview
                  preview-item.mb-12(:title="$t('document_preview')")
                    template(v-if="isFetching")
                      v-skeleton-loader.pa-4(type="list-item-three-line@6" style="width:80%")
                    template(v-else)
                      document-template-preview.mt-4(:header="headerData" :category="documentCategory" :content="content" :medicalCertificateData="medicalCertificateData" :prescriptionLetterData="prescriptionLetterData" :footerUrl="footerUrl" :footerAlignment="footerAlignment")
    v-card-actions.white.pa-0
      .d-flex.flex-column(style="width:100%")
        v-divider
        .d-flex.justify-end.pa-4
          v-btn.button-md.neutral700--text.underline.mr-2(text @click="onSave(false)") {{ $t('complete_later') }}
          v-btn.button-md(:loading="isLoading" color="primary" depressed @click="onSave(true)") {{ $t('complete_document') }}
    .dialogs
      unsaved-document-confirmation-dialog(v-if="openUnsavedDocumentConfirmationDialog" :open.sync="openUnsavedDocumentConfirmationDialog" @quitAndDiscard="onQuitAndDiscard" @saveAndQuit="onSave(true)")
      medical-document-select-date-dialog(v-if="openSelectDateDialog" :open.sync="openSelectDateDialog" :parentDateDetails="selectedDateDetails" @confirmed="onConfirmSelectedDate")
</template>

<script>
import { DateTime } from 'luxon'
import { mapState, mapGetters, mapActions } from 'vuex'
import TextEditor from '@/components/clinic/document/TextEditor.vue'
import Preview from '@/components/clinic/settings/Preview.vue'
import PreviewItem from '@/components/clinic/settings/PreviewItem.vue'
import UnsavedDocumentConfirmationDialog from '@/components/clinic/dialogs/UnsavedDocumentConfirmationDialog.vue'
import DocumentTemplatePreview from '@/components/clinic/document/preview/DocumentTemplatePreview.vue'
import MedicalDocumentSelectDateDialog from '@/components/clinic/dialogs/MedicalDocumentSelectDateDialog.vue'
import DiagnosisFieldDropdown from '@/components/clinic/consultation/diagnosis/DiagnosisFieldDropdown.vue'
import PrescriptionLetterMedicationSelection from '@/components/clinic/document/prescriptionLetter/PrescriptionLetterMedicationSelection.vue'
import PatientRelationshipDropdown from "@/components/clinic/relationship/PatientRelationshipDropdown.vue"

export default {
  components: {
    TextEditor, Preview, PreviewItem, UnsavedDocumentConfirmationDialog, DocumentTemplatePreview, MedicalDocumentSelectDateDialog,
    DiagnosisFieldDropdown, PrescriptionLetterMedicationSelection, PatientRelationshipDropdown
  },
  props: {
    open: {
      type: Boolean
    },
    selectedTreatment: {
      type: Object,
      default: null
    },
    leadPid: {
      type: String,
      required: true
    },
    newDocument: {
      type: Boolean
    },
    parentDiagnosis: {
      type: Array,
      default: () => {[]}
    },
    patient: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      openUnsavedDocumentConfirmationDialog: false,
      content: '',
      originalContent: '',
      headerData: {},
      footerUrl: null,
      footerAlignment: null,
      noOfDays: 1,
      visitDate: null,
      startDate: null,
      endDate: null,
      openSelectDateDialog: false,
      selectedDateDetails: null,
      providers: [],
      selectedProvider: null,
      selectedDiagnosis: [],
      medications: [],
      selectedPatientDependent: null
    }
  },
  async mounted () {
    this.isFetching = true
    let allFetching = [this.fetchDocumentHeader(), this.fetchProviders()]
    try {
      if (this.newDocument) {
        allFetching.push(this.fetchDocumentTemplate())
      }
      await Promise.all([...allFetching])
      this.mapDocumentData()
      this.isFetching = false
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
    }
  },
  watch: {
    startDate() {
      this.calculateEndDate()
    },
    endDate() {
      this.calculateNoOfDays()
    }
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany',
      isDoctor: 'user/isDoctor'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    documentName () {
      return this.selectedTreatment.productItem.name
    },
    hasChanges () {
      return this.originalContent !== this.content
    },
    documentTemplateParams () {
      return {
        company: this.company.id,
        product: this.selectedTreatment?.productItem?.id
      }
    },
    documentHeaderParams () {
      return {
        page_size: 1,
        company: this.company.id
      }
    },
    documentFooterUrl () {
      if (!this.footerEnabled) {
        return null
      }
      if (!this.footerImage) {
        return null
      }
      return this.footerImage.url || this.footerImage.file
    },
    documentTemplateDetails () {
      return this.selectedTreatment.productItem.document_template
    },
    documentCategory () {
      return this.documentTemplateDetails.category
    },
    todayDate () {
      return DateTime.local().toISODate()
    },
    medicalCertificateData () {
      if (this.documentCategory !== 'medical_certificate') return null

      let data = {
        visit_date: this.visitDate,
        doctor_name: this.selectedProvider,
        start_date: this.startDate,
        end_date: this.endDate,
        days_count: this.noOfDays,
        diagnosis: this.selectedDiagnosis,
        patient_dependent: this.selectedPatientDependent || null,
      }
      data.name = this.patient?.name || null
      data.age = this.patient?.dob ? this.$options.filters.displayAgeByYearMonthDay(this.$options.filters.getAgeByYearMonthDay(this.patient.dob)) : null
      data.ic = this.patient?.ic || null

      return data
    },
    prescriptionLetterData () {
      let data = {
        date: this.visitDate,
        doctor_name: this.selectedProvider,
        medications: this.medications
      }
      data.name = this.patient?.name || null
      data.ic = this.patient?.ic || null

      return data
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchDocumentTemplate () {
      return this.$axios.get('/document_templates', { params: this.documentTemplateParams })
        .then(({ data }) => {
          if (data.count > 0) {
            const result = data.results[0]
            const content = result.content
            this.content = content
            this.originalContent = content
            this.mapFooterData(result)
          }
        })
    },
    onClose () {
      if (this.hasChanges && this.documentCategory === 'medical_document') {
        this.openUnsavedDocumentConfirmationDialog = true
        return
      }
      this.showDialog = false
    },
    onSave (completed) {
      let number = this.selectedTreatment.number
      let items
      if (this.documentCategory === 'medical_certificate') {
        items = {...this.medicalCertificateData}
      } else if(this.documentCategory === 'prescription_letter') {
        items = {...this.prescriptionLetterData}
      } else {
        items = {
          content: this.content
        }
      }
      this.$emit('save', number, items, completed)
      this.showDialog = false
    },
    onQuitAndDiscard () {
      this.showDialog = false
    },
    fetchDocumentHeader () {
      return this.$axios.get('/document_template_headers', { params: this.documentHeaderParams })
        .then(({ data }) => {
          if (data.count > 0) {
            this.mapHeaderData(data)
          }
        })
    },
    fetchProviders () {
      const params = {
        page_size: -1,
        fields: 'id,name'
      }
      return this.$axios.get(`/clinics/${this.company.slug}/providers`, { params })
        .then(({ data }) => {
          if (data && data.results) {
            this.providers = data.results
          }
        })
    },
    mapHeaderData (data, isList = true) {
      let result
      if (isList) {
        result = data.results[0]
      } else {
        result = data
      }
      const { id, address, logo } = result
      this.id = id
      this.headerData.address = this.sanitizeAddress(address) ?? {}
      this.headerData.name = address?.name ?? null
      this.headerData.phone = address?.phone ?? null
      this.headerData.resizeImageFileUrl = logo?.file ?? ''
      this.originalHeader = result
    },
    sanitizeAddress (address) {
      if (address) {
        const allowedProperties = ['address_1', 'address_2', 'city', 'postcode', 'state', 'country']
        return this.$options.filters.filterAllowedObjectProperties(address, allowedProperties)
      }
      return null
    },
    mapFooterData (data) {
      const { footer_enabled, footer_image, footer_alignment } = data
      if (footer_enabled) {
        this.footerUrl = footer_image?.file || null
        this.footerAlignment = ['left', 'middle', 'right'].findIndex(item => item === footer_alignment)
      }
    },
    mapDocumentData () {
      if (this.newDocument) {
        if (this.documentCategory === 'medical_certificate') {
          this.visitDate = this.todayDate
          this.startDate = this.todayDate
          if (this.parentDiagnosis) {
            this.selectedDiagnosis = [...this.parentDiagnosis]
          }
          // Prefilled provider
          if (this.isDoctor && this.member.provider) {
            const found = this.providers.find(provider => provider.id === this.member.provider)
            if (found) {
              this.selectedProvider = found.name
            }
          }
        }
        if (this.documentCategory === 'prescription_letter') {
          this.visitDate = this.todayDate
          // Prefilled provider
          if (this.isDoctor && this.member.provider) {
            const found = this.providers.find(provider => provider.id === this.member.provider)
            if (found) {
              this.selectedProvider = found.name
            }
          }
        }
      } else {
        if (this.documentCategory === 'medical_certificate') {
          this.visitDate = this.selectedTreatment.productItem.documentData.visit_date
          this.selectedProvider = this.selectedTreatment.productItem.documentData.doctor_name
          this.startDate = this.selectedTreatment.productItem.documentData.start_date
          this.endDate = this.selectedTreatment.productItem.documentData.end_date
          this.noOfDays = this.selectedTreatment.productItem.documentData.days_count
          this.selectedDiagnosis = this.selectedTreatment.productItem.documentData.diagnosis
          this.selectedPatientDependent = this.selectedTreatment.productItem.documentData.patient_dependent
        } else if (this.documentCategory === 'prescription_letter') {
          this.visitDate = this.selectedTreatment.productItem.documentData.date
          this.selectedProvider = this.selectedTreatment.productItem.documentData.doctor_name
          this.medications = this.selectedTreatment.productItem.documentData.medications
        } else {
          this.originalContent = this.selectedTreatment.productItem.documentData.content
          this.content = this.selectedTreatment.productItem.documentData.content
        }
      }
    },
    onOpenSelectDateDialog (type) {
      const detailOptions = {
        visitDate: {
          title: 'Visit date',
          date: this.visitDate,
          type: 'visitDate'
        },
        startDate: {
          title: 'Start date',
          date: this.startDate,
          type: 'startDate',
        },
        endDate: {
          title: 'End date',
          date: this.endDate,
          type: 'endDate',
          minDate: this.startDate
        }
      }
      this.selectedDateDetails = detailOptions[type]
      this.openSelectDateDialog = true
    },
    onConfirmSelectedDate (date) {
      const selectDateType = this.selectedDateDetails.type
      switch (selectDateType) {
        case 'visitDate':
          this.visitDate = date
          break

        case 'startDate':
          this.startDate = date
          break

        case 'endDate':
          this.endDate = date
          break
      
        default:
          break
      }
    },
    onNoOfDaysChanged (value) {
      if (value < 1) {
        this.noOfDays = 1
      }
      this.calculateEndDate()
    },
    calculateEndDate () {
      this.endDate = DateTime.fromISO(this.startDate).plus({ days: this.noOfDays - 1 }).toISODate()
    },
    calculateNoOfDays () {
      const startDate = DateTime.fromISO(this.startDate)
      const endDate = DateTime.fromISO(this.endDate)
      const diff = endDate.diff(startDate, 'days').toObject()
      this.noOfDays = diff.days + 1
    },
    onUpdateDiagnosis (diagnosis) {
      this.selectedDiagnosis = diagnosis
    },
  }
};
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid var(--v-neutral300) !important;
}
.border-field {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-field {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
</style>